module.exports = __webpack_public_path__ + "img/graph.69ca0f7f.svg";